export const SET_DIGESTS_SUGGESTION_DATA = 'SET_DIGESTS_SUGGESTION_DATA';
export const CLEAN_DIGESTS_SUGGESTION_DATA = 'CLEAN_DIGESTS_SUGGESTION_DATA';



// WEBPACK FOOTER //
// ./src/redux_related/digestsSuggestions/actions.js